import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import { styled } from '@mui/system';
import { string, func, oneOf, elementType } from 'prop-types';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

const VisuallyHidden = styled('span')({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  top: 20,
  width: 1
});

const StyledTableSortLabel = styled(TableSortLabel)({
  '& .MuiTableSortLabel-icon': {
    opacity: 1
  }
});

/**
 * Renders MUI TableCell with TableSortLabel.
 * @returns {React.FC}
 */

const SortingColumn = ({
  width,
  title,
  id,
  orderBy,
  order,
  onRequestSort,
  CellComponent = TableCell,
  className
}) => {
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  const isActive = orderBy === id;

  const labelProp = {};

  if (!isActive) labelProp.IconComponent = UnfoldMoreIcon;

  return (
    <CellComponent
      width={width}
      sortDirection={isActive ? order : false}
      className={className}
    >
      <StyledTableSortLabel
        active={isActive}
        direction={orderBy === id ? order : 'asc'}
        onClick={createSortHandler(id)}
        {...labelProp}
      >
        {title}
        {isActive ? (
          <VisuallyHidden>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </VisuallyHidden>
        ) : null}
      </StyledTableSortLabel>
    </CellComponent>);
};

SortingColumn.propTypes = {
  onRequestSort: func.isRequired,
  order: oneOf(['asc', 'desc']).isRequired,
  orderBy: string.isRequired,
  CellComponent: elementType
};

export default SortingColumn;
